import { FunctionComponent } from 'react';

import { MotorFullPageProps, MotorStepType } from 'scenes/motor/types';

import {
  AddDriverStep,
  BusinessTypeStep,
  ClaimsMadeStep,
  FlybuysStep,
  GenderAndDateOfBirthStep,
  NameStep,
  OvernightParkingStep,
  PayableClaimsStep,
  PolicyStartDateStep,
  RecentInsurerStep,
  RegoSearchStep,
  UsedForBusinessStep,
  VehicleDetailConfirmationStep,
  VehicleFinancierStep,
  VehicleManualStep,
  YearsDrivingStep,
  FinanceStep,
  AddPolicyHolderStep,
  PersonalOrBusinessPolicyStep,
  BusinessNameAndAbnStep,
  BusinessRegisteredForGstStep,
  PersonalPolicyContactStep,
  ContactPhoneNumberStep,
  ContactEmailAddressStep,
  PostalAddressStep,
  DifferentPostalAddressStep,
  DifferentPostalAddressManualStep,
  LockedBagAddressStep,
  BusinessContactStep,
  QuotePriceStep,
  MarketAgreedValueStep,
  ExcessStep,
  OptionalExtrasStep,
  CoverForDriversUnder25Step,
  PreExistingDamageStep,
  MissingRegoStep,
  ModificationsStep,
  ModificationsSelectionStep,
  SpecialFeaturesStep,
  SpecialDetailsStep,
  InsuredSincePossessedStep,
  TermsAndConditionsStep,
  PaymentFrequencyStep,
  PaymentDateStep,
  PaymentMethodStep,
  DirectDebitPaymentStep,
  CreditCardPaymentStep,
  PaymentConfirmationStep,
  SummaryStep,
  ReviewPolicyStartDateStep,
  ReviewDriverDetailsStep,
} from '.';
import PromoCodeStep from './QuoteDetails/PromoCodeStep';

const stepRoutes: {
  [s in MotorStepType]: FunctionComponent<MotorFullPageProps>;
} = {
  [MotorStepType.Name]: NameStep,
  [MotorStepType.GenderAndDateOfBirth]: GenderAndDateOfBirthStep,
  [MotorStepType.OvernightParking]: OvernightParkingStep,
  [MotorStepType.YearsDriving]: YearsDrivingStep,
  [MotorStepType.ClaimsMade]: ClaimsMadeStep,
  [MotorStepType.PayableClaims]: PayableClaimsStep,
  [MotorStepType.RecentInsurer]: RecentInsurerStep,
  [MotorStepType.UsedForBusiness]: UsedForBusinessStep,
  [MotorStepType.BusinessType]: BusinessTypeStep,
  [MotorStepType.Finance]: FinanceStep,
  [MotorStepType.VehicleFinancier]: VehicleFinancierStep,
  [MotorStepType.CoverForDriversUnder25]: CoverForDriversUnder25Step,
  [MotorStepType.PolicyStartDate]: PolicyStartDateStep,
  [MotorStepType.AddDriver]: AddDriverStep,
  [MotorStepType.RegoSearch]: RegoSearchStep,
  [MotorStepType.VehicleManualSelect]: VehicleManualStep,
  [MotorStepType.VehicleDetails]: VehicleDetailConfirmationStep,
  [MotorStepType.FlybuysNumber]: FlybuysStep,
  [MotorStepType.PromoCode]: PromoCodeStep,
  [MotorStepType.QuotePrice]: QuotePriceStep,
  [MotorStepType.Excess]: ExcessStep,
  [MotorStepType.MarketAgreedValue]: MarketAgreedValueStep,
  [MotorStepType.OptionalExtras]: OptionalExtrasStep,
  [MotorStepType.PersonalOrBusinessPolicy]: PersonalOrBusinessPolicyStep,
  [MotorStepType.BusinessNameAndAbn]: BusinessNameAndAbnStep,
  [MotorStepType.BusinessRegisteredForGst]: BusinessRegisteredForGstStep,
  [MotorStepType.AddPolicyHolder]: AddPolicyHolderStep,
  [MotorStepType.PersonalPolicyContact]: PersonalPolicyContactStep,
  [MotorStepType.BusinessContact]: BusinessContactStep,
  [MotorStepType.ContactPhoneNumber]: ContactPhoneNumberStep,
  [MotorStepType.ContactEmailAddress]: ContactEmailAddressStep,
  [MotorStepType.PostalAddress]: PostalAddressStep,
  [MotorStepType.DifferentPostalAddress]: DifferentPostalAddressStep,
  [MotorStepType.DifferentPostalAddressManual]: DifferentPostalAddressManualStep,
  [MotorStepType.LockedBagAddress]: LockedBagAddressStep,
  [MotorStepType.PreExistingDamage]: PreExistingDamageStep,
  [MotorStepType.Modifications]: ModificationsStep,
  [MotorStepType.ModificationSelection]: ModificationsSelectionStep,
  [MotorStepType.SpecialFeatures]: SpecialFeaturesStep,
  [MotorStepType.SpecialDetails]: SpecialDetailsStep,
  [MotorStepType.InsuredSincePossessed]: InsuredSincePossessedStep,
  [MotorStepType.MissingRegoStep]: MissingRegoStep,
  [MotorStepType.TermsAndConditions]: TermsAndConditionsStep,
  [MotorStepType.Summary]: SummaryStep,
  [MotorStepType.PaymentFrequency]: PaymentFrequencyStep,
  [MotorStepType.PaymentDate]: PaymentDateStep,
  [MotorStepType.PaymentMethod]: PaymentMethodStep,
  [MotorStepType.DirectDebitPayment]: DirectDebitPaymentStep,
  [MotorStepType.CreditCardPayment]: CreditCardPaymentStep,
  [MotorStepType.PaymentConfirmation]: PaymentConfirmationStep,
  [MotorStepType.ReviewPolicyStartDate]: ReviewPolicyStartDateStep,
  [MotorStepType.ReviewDriverDetails]: ReviewDriverDetailsStep,
  [MotorStepType.addDriverName]: ReviewDriverDetailsStep,
};

export default stepRoutes;
